<div class="border-1 bg-white p-4 border-round-lg border-gray-400 flex">
  <div class="border-right-1 border-gray-400 mr-2 w-12rem">
    <h3>{{ task.vehicleReg }}</h3>
    <p>{{ task.vehicle }}</p>
    <div class="flex gap-2 align-items-center" *ngIf="task.supplierTransportModeToPickup != null">
      <transport-icon-switch [mode]="task.supplierTransportModeToPickup"></transport-icon-switch>
      <p class="mr-1">{{ transportModeText }} to pick-up</p>
    </div>

    <button
      *ngIf="!isVME"
      pButton
      [label]="'Edit Schedule'"
      class="ui-button-secondary my-2 mx-0"
      (click)="onEditSchedule()"
    ></button>
  </div>

  <div>
    <vertical-dots-container [position]="'start'" [narrowDots]="true" iconSize="small">
    </vertical-dots-container>

    <vertical-dots-container
      [position]="'end'"
      [narrowDots]="true"
      iconSize="small"
      [iconClass]="'fa fa-circle'"
    >
      <div class="-mt-3">
        <h3 class="my-0">{{ task.pickupAddress }}</h3>
        <div class="flex gap-2 align-items-center">
          <i class="fa fa-calendar"></i>
          <p>{{ travelSchedulerService.formatScheduleWindowText(task.supplierPickupWindow) }}</p>
        </div>

        <p class="text-green-500 py-2 border-top-1 border-bottom-1 border-gray-400 m-0">
          {{ task.taskMileage }} mi, {{ task.taskDurationMinutes | minutesToHoursMinutes }}
        </p>
        <h3 class="mb-0">{{ task.dropoffAddress }}</h3>
        <div class="flex gap-2 align-items-center">
          <i class="fa fa-calendar"></i>
          <p>{{ travelSchedulerService.formatScheduleWindowText(task.supplierDropoffWindow) }}</p>
        </div>
      </div>

      <div *ngIf="isVME">
        <div
          *ngFor="let subcategory of task.checklistSubCategories"
          style="margin-top: 7px; margin-right: 7px"
        >
          <checklist-category-item
            [subCategory]="subcategory.checklistSubCategory"
          ></checklist-category-item>
        </div>
      </div>
    </vertical-dots-container>
  </div>
</div>
